/**
 * @file The Customers list's columns, shared with the group preview so both tables show and sort an
 * account the same way. `lookup` is the core-service ordering key when it differs from parent__key.
 */
import type { Field } from '@/components/Table/fields'
import { MessageSquareDot } from 'lucide-vue'

export const baseFields: Field[] = [
  {
    checkbox: {
      ignore: undefined,
      ignoreBy: undefined
    },
    key: 'checkbox',
    label: ''
  },
  {
    parent: 'customer',
    label: '',
    key: 'unread_messages',
    sortable: true,
    icon: {
      iconName: MessageSquareDot,
      title: 'Unread Messages'
    }
  },
  {
    parent: 'customer',
    key: 'first_name',
    sortable: true
  },
  {
    parent: 'customer',
    key: 'last_name',
    sortable: true
  },
  {
    parent: 'customer',
    key: 'sms_phone_number',
    label: 'Cell Phone',
    type: 'phone'
  },
  {
    parent: 'account',
    key: 'amount_due',
    type: 'amount',
    sortable: true
  },
  {
    parent: 'account',
    key: 'due_date',
    lookup: 'account__current_invoice__due_date',
    sortable: true
  },
  {
    label: 'Days Overdue',
    key: 'overdue',
    lookup: 'account__current_invoice__due_date',
    sortable: true
  },
  {
    parent: 'customer',
    key: 'email',
    sortable: true
  },
  {
    parent: 'account',
    key: 'promise_date',
    label: 'Promise',
    type: 'promise-date',
    sortable: true
  },
  {
    key: 'last_worked',
    label: 'Last Worked',
    type: 'last-worked',
    sortable: true
  },
  {
    key: 'follow_up',
    label: 'Follow-up',
    type: 'follow-up',
    sortable: true
  },
  {
    parent: 'account',
    key: 'external_id',
    sortable: true
  },
  {
    parent: 'account',
    key: 'name',
    label: 'Account Name'
  },
  {
    parent: 'account',
    key: 'merchant_location',
    label: 'Location',
    // Display reads item.account.merchant_location (resolved to the location
    // name in callback()); sort server-side by the location name.
    lookup: 'account__merchant_location__name',
    sortable: true
  },
  {
    parent: 'account',
    key: 'status',
    label: 'Status',
    type: 'account-status',
    sortable: true
  }
]

// 'overdue', 'status' and 'follow_up' are filter-driven columns: hidden by default and auto-shown
// while their matching filter (Days Overdue / multi-status Account Status / any follow-up filter)
// is active. 'name' and 'merchant_location' are plain default-hidden columns (no auto-show).
export const DEFAULT_HIDDEN_COLUMN_KEYS = [
  'name',
  'merchant_location',
  'overdue',
  'status',
  'follow_up'
]
